import './componenets/side-bar-student-item.css';
import React from 'react';
import {
  SideBarStudentItem,
  StudentSideBarItemType,
} from './componenets/side-bar-student-item';

export interface SideBarStudentModel {
  onClick: (type: StudentSideBarItemType) => void;
}

export const SideBarStudent: React.FC<SideBarStudentModel> = ({ onClick }) => {
  return (
    <div style={{ width: '250px', marginLeft: '16px' }}>
      <div className="sidebar-section">
        <h3 className="section-title">מידע אישי</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.PROFILE}
          text={'פרטים אישיים'}
          onClick={onClick}
        />
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">לימודים</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.ACADEMIC}
          text={'תוכניות לימודים'}
          onClick={onClick}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.LECTURES}
          text={'מפגשים'}
          onClick={onClick}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.EXAMS}
          text={'מבחנים'}
          onClick={onClick}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.ASSIGNMENTS}
          text={'מטלות'}
          onClick={onClick}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.EXTERNAL_EXAMS}
          text={'מבחנים חיצוניים'}
          onClick={onClick}
        />
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">שירותים</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.DOCS}
          text={'מסמכים'}
          onClick={onClick}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.PAYMENT_SERVICES}
          text={'שרותי תשלום'}
          onClick={onClick}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.INSTALLMENTS_CREDIT_CARD}
          text={'הוראות קבע באשראי'}
          onClick={onClick}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.INSTALLMENTS_BANK_TRANSFER}
          text={'הוראות קבע בהעברה בנקאית'}
          onClick={onClick}
        />
      </div>
    </div>
  );
};
